export const regionsList : string[] = [
    "Africa",
    "America",
    "Asia",
    "Europe",
    "Oceania"
]